module.exports = __webpack_public_path__ + "media/images/user_thumb/missing_photo-4a1f555619ad498c7a70ec0b9ff945d1.gif";